import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    standalone: false,
    template: ` <a [href]="value" target="_blank">{{ parsedValue }}</a> `,
})
export class DetailPageRenderer implements ICellRendererAngularComp {
    // Init Cell Value
    public value!: string;
    public parsedValue!: string;
    agInit(params: ICellRendererParams): void {
        this.refresh(params);
    }
    constructor(private router: Router) {}

    // Return Cell Value
    refresh(params: ICellRendererParams): boolean {
        const data = params.data;
        if(data) {
            this.value = this.router.serializeUrl(
              this.router.createUrlTree(['details/'+data.name])
            );
            this.parsedValue = params.value;
            return true;
        }
        return true;
    }
}
